// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { ControlloCostiPerMissioneDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class ControlloCostiPerMissioneApiClient extends BaseCRUDApiClient<ControlloCostiPerMissioneDto> {
  baseUrl = this.config.apiEndpoint + '/prima-nota-riga';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  override getAll() {
    this._pagedCache.clear();
    return this.http.get<ControlloCostiPerMissioneDto[]>(
      `${this.baseUrl}/controllo-costi-per-missione`
    );
  }
}
